import { render, staticRenderFns } from "./ed-presentation-mode-navigation-toggle.component.vue?vue&type=template&id=35a6c1b8&scoped=true&"
import script from "./ed-presentation-mode-navigation-toggle.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-navigation-toggle.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-navigation-toggle.component.scss?vue&type=style&index=0&id=35a6c1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6c1b8",
  null
  
)

export default component.exports